import appBar from './app-bar.json'
import button from './button.json'
import common from './common.json'
import contact from './contact.json'
import footer from './footer.json'

export const zhHant = {
  appBar,
  button,
  contact,
  footer,
  common,
}
